export default __webpack_public_path__ + "static/media/upload (4) 1.4a54171e.svg";